import { Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import appConfig from "../../config/appConfig";

import Signup from "./Signup";
import Dashboard from "./Dashboard";
import Analytics from "./Analytics";
import Links from "./Links";
import Referrals from "./Referrals";
import Commissions from "./Commissions";
import Payouts from "./Payouts";

const AffiliateRouter = () => (
    <Routes>
        <Route path="/"            element={<Navigate to="dashboard" replace />} />
        <Route path="/signup"      element={<><Sidebar /><Signup    pageTitle={appConfig.pageTitle("Become an affiliate")} /></>} />
        <Route path="/dashboard"   element={<><Sidebar /><Dashboard pageTitle={appConfig.pageTitle("Affiliate dashboard")} /></>} />
        <Route path="/analytics"   element={<><Sidebar /><Analytics pageTitle={appConfig.pageTitle("Affiliate analytics")} /></>} />
        <Route path="/links"       element={<><Sidebar /><Links     pageTitle={appConfig.pageTitle("Affiliate links")} /></>} />
        <Route path="/referrals"   element={<><Sidebar /><Referrals pageTitle={appConfig.pageTitle("Referrals")} /></>} />
        <Route path="/commissions" element={<><Sidebar /><Commissions pageTitle={appConfig.pageTitle("Commissions")} /></>} />
        <Route path="/payouts"     element={<><Sidebar /><Payouts   pageTitle={appConfig.pageTitle("Payouts")} /></>} />
    </Routes>
);

export default AffiliateRouter;
